module.exports = __webpack_public_path__ + "media/fonts/Roboto-Medium-13a29228654d5c5ec9c482a267efa4af.ttf";